import styles from './SizePanel.module.scss';
import React from 'react';
import cn from 'classnames';

interface SizePanelProps {
  label: string;
  selected: boolean;
  handleClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function formatLabelString(label: string) {
  return label.replace(';', ' - ');
}

const SizePanel = ({ label, selected, handleClick }: SizePanelProps) => {
  return (
    <label
      className={cn(styles.sizePanel, { [styles.panelClicked]: selected })}
    >
      <input
        type="checkbox"
        checked={selected}
        onChange={handleClick}
        className={styles.checkbox}
      />
      <div>{formatLabelString(label)}</div>
    </label>
  );
};

export default SizePanel;
